import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import app from './modules/app';
import settings from './modules/settings';
import user from './modules/user';
import tagsView from './modules/tagsView';
import message from './modules/message';
import system from './modules/system';
import search from './modules/search';
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app,
    settings: settings,
    user: user,
    tagsView: tagsView,
    message: message,
    system: system,
    search: search
  },
  getters: getters
});
export default store;